import Accordion from '../../../common/components/accordion/accordion.vue';
import monthToYear from '../../../common/js/month-to-year-filter/month-to-year-filter';
export default {
	name: 'personalLoanCalculatorKo2021Result',
	data() {
		return {
			detailsOpened: false
		};
	},
	props: {
		model: {
			required: true
		},
		higherIncome: {
			required: true
		}
	},
	filters: {
		monthToYear
	},
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		loanAmount() {
			return this.model.loanAmount + this.model.disbursementFee;
		}
	},
	components: {
		Accordion
	},
	methods: {},
	watch: {
		model(newValue) {
			if (newValue) {
				this.model = newValue;
			}
		}
	}
};
